export default __webpack_public_path__ + "static/rupam-b8ef7a9bd449a5d1d76f59edf3e60ddb.jpg";